import React, { Component } from "react";
import { Link } from "react-router-dom";
import { _t } from "../util/Translator";

class AcceptLopdConfirmationScreen extends Component {
  state = {};
  render() {
    return (
      <div className="site-section">
        <div className="container col-md-12">
          <div className="col-md-12">
            <h1>{_t("acceptLopd.title")}</h1>
          </div>
          <div className="col-md-12">
            <p>
              {_t("acceptLopd.statement")} 
              <Link to="/home/politicaDePrivacidad">{_t("footer.privacyPolicy")}</Link>&nbsp;/&nbsp;
              <Link to="/home/terminosYCondiciones">{_t("footer.termsAndConditions")}</Link>&nbsp;/&nbsp;
              <Link to="/home/proteccionDeDatos">{_t("footer.dataProtection")}</Link>
            </p>            
          </div>
        </div>
      </div>
    );
  }
}

export default AcceptLopdConfirmationScreen;
